import { useState } from "react";
import type { Role } from "../types";
import { Eye, Shield } from "./icons";

interface AuthScreenProps {
  onLogin: (role: Role, password: string) => Promise<void>;
}

export function AuthScreen({ onLogin }: AuthScreenProps) {
  const [role, setRole] = useState<Role>("viewer");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  return (
    <main className="auth-page">
      <section className="auth-panel">
        <div className="brand-mark" aria-hidden="true"><span>5</span></div>
        <p className="eyebrow">TEAM PLAYBOOK</p>
        <h1>一套战术，<br />全队看懂。</h1>
        <p className="auth-intro">输入球队口令，打开共享战术库。</p>

        <div className="role-tabs" role="tablist" aria-label="选择登录身份">
          <button className={role === "viewer" ? "active" : ""} onClick={() => setRole("viewer")}>
            <Eye size={17} /> 队员查看
          </button>
          <button className={role === "coach" ? "active" : ""} onClick={() => setRole("coach")}>
            <Shield size={17} /> 教练管理
          </button>
        </div>

        <form onSubmit={async (event) => {
          event.preventDefault();
          setError("");
          setSubmitting(true);
          try {
            await onLogin(role, password);
          } catch (caught) {
            setError(caught instanceof Error ? caught.message : "登录失败，请重试");
          } finally {
            setSubmitting(false);
          }
        }}>
          <label htmlFor="team-password">{role === "coach" ? "教练管理口令" : "球队查看口令"}</label>
          <input
            id="team-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="输入口令"
            autoFocus
          />
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="primary wide" type="submit" disabled={!password || submitting}>
            {submitting ? "正在验证…" : "进入战术库"}
          </button>
        </form>
        <p className="auth-footnote">你的登录状态只保存在当前设备，有效期 7 天。</p>
      </section>
      <aside className="auth-court" aria-hidden="true">
        <div className="hero-court-lines" />
        <div className="hero-player p1">1</div>
        <div className="hero-player p2">2</div>
        <div className="hero-player p3">5</div>
        <svg className="hero-arrow" viewBox="0 0 240 180"><path d="M15 160 C70 30 135 155 218 32" /></svg>
        <p>READ THE FLOOR.<br /><strong>MOVE AS ONE.</strong></p>
      </aside>
    </main>
  );
}
